import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ChatTemplate from '../templates/ChatTemplate';
import VocabularyPanel from '../molecules/VocabularyPanel';
import MissionsModal from '../molecules/MissionsModal';
import OrbitalCharacterModels from '../molecules/OrbitalCharacterModels';
import SEO from '../atoms/SEO';
import { useChat } from '../../context/ChatContext';
import './ChatPage.css';

const characterModels = [
  { src: '/models/ni.glb', character: '你' },
  { src: '/models/hao.glb', character: '好' },
  { src: '/models/wen.glb', character: '问' },
  { src: '/models/zhong.glb', character: '中' }
];

const ChatPage = () => {
  const navigate = useNavigate();
  const { startConversation, conversationStarted } = useChat();
  const [vocabularyOpen, setVocabularyOpen] = useState(false);
  const [missionsOpen, setMissionsOpen] = useState(false);
  const [activeMissionId, setActiveMissionId] = useState(null);

  useEffect(() => {
    if (!conversationStarted) {
      startConversation();
    }
  }, [startConversation, conversationStarted]);

  const handleBackClick = () => {
    navigate('/');
  };

  return (
    <div className="chat-page">
      <SEO
        title="Chat with Your Teacher"
        description="Have a conversation with your Chinese teacher and improve your language skills."
      />
      <OrbitalCharacterModels models={characterModels} centerX={50} centerY={50} />

      <div className={`chat-workspace ${vocabularyOpen ? 'vocab-open' : ''}`}>
        <div className="chat-container">
          <ChatTemplate
            onBackClick={handleBackClick}
            vocabularyOpen={vocabularyOpen}
            onToggleVocabulary={() => setVocabularyOpen((open) => !open)}
            missionsOpen={missionsOpen}
            onToggleMissions={() => setMissionsOpen((open) => !open)}
          />
        </div>
        <VocabularyPanel
          open={vocabularyOpen}
          onClose={() => setVocabularyOpen(false)}
        />
      </div>

      <MissionsModal
        open={missionsOpen}
        onClose={() => setMissionsOpen(false)}
        activeMissionId={activeMissionId}
        onSelectMission={setActiveMissionId}
      />
    </div>
  );
};

export default ChatPage;
